/** German. */
export const de = {
    common: {
        save: 'Speichern',
        saving: 'Wird gespeichert…',
        saved: 'Gespeichert',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        close: 'Schließen',
        back: 'Zurück',
        retry: 'Erneut versuchen',
        loading: 'Wird geladen…',
        search: 'Suchen',
        signOut: 'Abmelden',
        store: 'Shop',
        status: 'Status',
        email: 'E-Mail',
        password: 'Passwort',
        firstName: 'Vorname',
        lastName: 'Nachname',
        phone: 'Telefon',
        total: 'Gesamt',
        subtotal: 'Zwischensumme',
        quantity: 'Menge',
        price: 'Preis',
        stock: 'Bestand',
        language: 'Sprache',
        never: 'Nie',
        none: '—',
    },
    nav: {
        products: 'Produkte',
        orders: 'Bestellungen',
        customers: 'Kundschaft',
        settings: 'Einstellungen',
        website: 'Website',
        apps: 'Apps',
        themes: 'Themes',
        installs: 'Installationen',
    },
    auth: {
        signInTitle: 'Anmelden',
        signInSubtitle: 'Melden Sie sich bei Ihrer Shop-Verwaltung an.',
        partnerSubtitle: 'Entwickeln Sie Apps und Themes für Händler.',
        signIn: 'Anmelden',
        signingIn: 'Anmeldung läuft…',
        createStore: 'Shop eröffnen',
        creatingStore: 'Shop wird erstellt…',
        haveAccount: 'Sie haben schon einen Shop? Anmelden',
        needAccount: 'Noch kein Shop? Jetzt eröffnen',
        storeName: 'Shop-Name',
        storeAddress: 'Shop-Adresse',
        passwordHint: 'Mindestens 12 Zeichen',
        slugChecking: 'Verfügbarkeit wird geprüft…',
        slugTaken: '{{slug}} ist bereits vergeben. Wir schlagen {{suggestion}} vor.',
        slugFree: '{{slug}} ist verfügbar.',
    },
    products: {
        title: 'Produkte',
        searchPlaceholder: 'Nach Titel, Handle oder Anbieter suchen…',
        newProduct: 'Neues Produkt',
        columnProduct: 'Produkt',
        columnPrice: 'Preis',
        columnStock: 'Bestand',
        columnVariants: 'Varianten',
        statusActive: 'Aktiv',
        statusDraft: 'Entwurf',
        statusArchived: 'Archiviert',
        empty: 'Noch keine Produkte. Legen Sie Ihr erstes an, um zu verkaufen.',
        variantCount: { one: '{{count}} Variante', other: '{{count}} Varianten' },
        stockLevel: {
            zero: 'Ausverkauft',
            one: '{{count}} auf Lager',
            other: '{{count}} auf Lager',
        },
        variantTitle: 'Variantenname',
        sku: 'Artikelnummer',
        couldNotLoadVariants: 'Varianten konnten nicht geladen werden.',
    },
    orders: {
        title: 'Bestellungen',
        searchPlaceholder: 'Nach Bestellnummer oder E-Mail suchen…',
        columnOrder: 'Bestellung',
        columnCustomer: 'Kundin/Kunde',
        columnPayment: 'Zahlung',
        columnFulfilment: 'Abwicklung',
        columnPlaced: 'Eingegangen',
        shipTo: 'Lieferadresse',
        item: 'Artikel',
        qty: 'Anz.',
        unit: 'Einzelpreis',
        empty: 'Noch keine Bestellungen.',
        itemCount: { one: '{{count}} Artikel', other: '{{count}} Artikel' },
        financial: {
            PENDING: 'Zahlung ausstehend',
            AUTHORIZED: 'Autorisiert',
            PAID: 'Bezahlt',
            PARTIALLY_REFUNDED: 'Teilweise erstattet',
            REFUNDED: 'Erstattet',
            VOIDED: 'Storniert',
        },
        fulfilment: {
            UNFULFILLED: 'Nicht abgewickelt',
            PARTIAL: 'Teilweise abgewickelt',
            FULFILLED: 'Abgewickelt',
            RESTOCKED: 'Wieder eingelagert',
        },
    },
    customers: {
        title: 'Kundschaft',
        searchPlaceholder: 'Nach Name oder E-Mail suchen…',
        newCustomer: 'Neue Kundin/neuer Kunde',
        columnCustomer: 'Kundin/Kunde',
        columnOrders: 'Bestellungen',
        columnMarketing: 'Marketing',
        lifetimeSpend: 'Gesamtumsatz',
        acceptsMarketing: 'Marketing erlaubt',
        empty: 'Noch keine Kundschaft.',
        orderCount: {
            zero: 'Keine Bestellungen',
            one: '{{count}} Bestellung',
            other: '{{count}} Bestellungen',
        },
    },
    settings: {
        title: 'Shop-Einstellungen',
        storefront: 'Ihr Shop',
        storefrontHint: 'Er ist bereits online. In der lokalen Entwicklung steht die Subdomain nicht im DNS — der Storefront-Dev-Server setzt stattdessen den Host-Header.',
        details: 'Angaben',
        customDomain: 'Eigene Domain',
        customDomainHint: 'Richten Sie einen CNAME auf Upweo und tragen Sie nur den Hostnamen ein. Leer lassen, um die Adresse oben zu verwenden.',
        addressHint: '{{host}} — eine Änderung macht bestehende Links ungültig',
        currency: 'Währung',
        country: 'Land',
        plan: 'Tarif',
        currencyLocked: 'Die Währung lässt sich nicht mehr ändern, sobald Bestellungen vorliegen — historische Summen wären sonst bedeutungslos.',
        languages: 'Sprachen',
        defaultLanguage: 'Standardsprache',
        defaultLanguageHint: 'Was Kundinnen und Kunden sehen, wenn ihr Browser eine Sprache anfragt, die Sie nicht anbieten.',
        storefrontLanguages: 'Shop-Sprachen',
        storefrontLanguagesHint: 'Kundinnen und Kunden können zwischen den angehakten Sprachen wechseln. Haken Sie eine ab, um sie auszublenden, statt einen halb übersetzten Shop zu zeigen.',
        saveFailed: 'Einstellungen konnten nicht gespeichert werden',
    },
    payments: {
        title: 'Zahlungen',
        testMode: 'Testmodus',
        live: 'Live',
        needsWebhook: 'Webhook fehlt',
        notConnected: 'Nicht verbunden',
        account: 'Konto',
        secretKey: 'Geheimer Schlüssel',
        publishableKey: 'Veröffentlichbarer Schlüssel',
        webhookSecret: 'Webhook-Signaturschlüssel',
        verified: 'Geprüft',
        webhookEndpoint: 'Webhook-Endpunkt',
        connect: 'Stripe verbinden',
        update: 'Schlüssel aktualisieren',
        disconnect: 'Trennen',
        verifying: 'Wird geprüft…',
        savedAndVerified: 'Gespeichert und geprüft',
        copy: 'Kopieren',
        copied: 'Kopiert',
        disabledNotConnected: 'Der Checkout ist deaktiviert, bis ein Stripe-Konto verbunden ist. Kundinnen und Kunden können stöbern und einen Warenkorb füllen, aber nicht bezahlen.',
        disabledNoWebhook: 'Ihre Schlüssel sind gespeichert, der Checkout bleibt aber aus, bis ein Webhook-Signaturschlüssel hinterlegt ist. Ohne ihn können wir eine Zahlung starten, aber nie erfahren, dass sie erfolgreich war — Bestellungen blieben unbezahlt, während das Geld bei Stripe eingeht.',
        secretKeyHintNew: 'Beginnt mit sk_ oder rk_. Wird verschlüsselt gespeichert und nie wieder angezeigt.',
        secretKeyHintExisting: 'Leer lassen, um den bereits gespeicherten Schlüssel zu behalten.',
        publishableKeyHint: 'Beginnt mit pk_. Wird an den Browser der Kundschaft gesendet und ist daher bewusst öffentlich.',
        webhookSecretHint: 'Beginnt mit whsec_. Stripe zeigt ihn nur einmal an, wenn Sie den Endpunkt oben anlegen.',
        saveFailed: 'Zahlungseinstellungen konnten nicht gespeichert werden',
        disconnectFailed: 'Verbindung konnte nicht getrennt werden',
    },
    shop: {
        shopAll: 'Alles ansehen',
        searchPlaceholder: 'Suchen…',
        soldOut: 'Ausverkauft',
        addToCart: 'In den Warenkorb',
        adding: 'Wird hinzugefügt…',
        options: 'Optionen',
        productNotFound: 'Produkt nicht gefunden',
        continueShopping: 'Weiter einkaufen',
        poweredBy: '{{store}} — betrieben mit Upweo',
        cart: 'Warenkorb',
        cartEmpty: 'Ihr Warenkorb ist leer',
        decreaseQuantity: 'Menge verringern',
        increaseQuantity: 'Menge erhöhen',
        remove: 'Entfernen',
        taxNotice: 'Steuern und Versand sind noch nicht berechnet.',
        checkout: 'Zur Kasse',
        contact: 'Kontakt',
        shippingAddress: 'Lieferadresse',
        address: 'Adresse',
        city: 'Stadt',
        postcode: 'Postleitzahl',
        country: 'Land',
        orderSummary: 'Bestellübersicht',
        editCart: 'Warenkorb bearbeiten',
        continueToPayment: 'Weiter zur Zahlung · {{total}}',
        preparingPayment: 'Zahlung wird vorbereitet…',
        payment: 'Zahlung',
        pay: '{{total}} bezahlen',
        paying: 'Zahlung läuft…',
        paymentSecurity: 'Zahlungen werden von Stripe abgewickelt. Ihre Kartendaten erreichen diesen Shop nie.',
        paymentFailed: 'Die Zahlung ist fehlgeschlagen. Versuchen Sie eine andere Karte.',
        thankYou: 'Vielen Dank',
        orderPaid: 'Bestellung {{order}} über {{total}} ist bezahlt.',
        confirmationSent: 'Eine Bestätigung ist unterwegs an {{email}}.',
        cartCount: { zero: 'Warenkorb', one: 'Warenkorb ({{count}})', other: 'Warenkorb ({{count}})' },
    },
    partner: {
        title: 'Upweo Partners',
        apps: 'Apps',
        newApp: 'Neue App',
        clientId: 'Client-ID',
        clientSecret: 'Client-Secret',
        scopes: 'Berechtigungen',
        requestedScopes: 'Angeforderte Berechtigungen',
        installs: 'Installationen',
        grantedScopes: 'Erteilte Berechtigungen',
        installed: 'Installiert',
        themes: 'Themes',
        noThemes: 'Noch keine Themes.',
        noApps: 'Noch keine Apps.',
        activePartnerAccount: 'Aktives Partnerkonto',
        installCount: {
            zero: 'Nicht installiert',
            one: '{{count}} Installation',
            other: '{{count}} Installationen',
        },
    },
    website: {
        subtitle: 'Die öffentliche Website unter upweo.com',
        copy: 'Marketing-Texte',
        copyHint: 'Lassen Sie ein Feld leer, um den mitgelieferten Text zu verwenden. Der ausgegraute Text ist der aktuelle Standard für diese Sprache.',
        clearHint: 'Ein geleertes Feld stellt den Standardtext wieder her.',
        pricing: 'Preispläne',
        pricingHint: 'Preise erscheinen im Zahlenformat der Besucherin. Übersetzt wird nur der Text — die Zahl ist überall dieselbe.',
        published: 'Live',
        hidden: 'Verborgen',
        publish: 'Veröffentlichen',
        hide: 'Verbergen',
        popular: 'Am beliebtesten',
    },
    site: {
        nav: {
            features: 'Funktionen',
            pricing: 'Preise',
            partners: 'Partner',
            signIn: 'Anmelden',
            startFree: 'Kostenlos starten',
        },
        hero: {
            title: 'Alles, was Sie zum Onlineverkauf brauchen',
            subtitle: 'Upweo gibt Ihnen einen Shop, eine Kasse und die Werkzeuge für das Geschäft dahinter — in Ihrer Sprache, in Ihrer Währung, auf Ihrer eigenen Domain.',
            ctaPrimary: 'Shop eröffnen',
            ctaSecondary: 'Preise ansehen',
            note: 'Zum Starten ist keine Karte nötig.',
        },
        features: {
            heading: 'Für echte Shops gebaut',
            subheading: 'Die mühsamen Teile eines Onlinegeschäfts — schon erledigt.',
            f1Title: 'Ihr eigener Shop',
            f1Body: 'Jeder Shop bekommt bei der Anmeldung sofort seine Adresse und kann jederzeit auf Ihre eigene Domain umziehen.',
            f2Title: 'Produkte und Bestand',
            f2Body: 'Varianten mit eigenem Preis und eigener Artikelnummer, Bestand je Lagerort, und Ware wird mit der Bestellung reserviert.',
            f3Title: 'Echte Zahlungen',
            f3Body: 'Verbinden Sie Ihr eigenes Stripe-Konto. Das Geld Ihrer Kundschaft geht direkt an Sie — wir stehen nie dazwischen.',
            f4Title: 'Spricht die Sprache Ihrer Kundschaft',
            f4Body: 'Sechs Sprachen, Unterstützung für Rechts-nach-links, und Preise so formatiert, wie jedes Land sie schreibt. Belege kommen in der Sprache an, die der Kunde gelesen hat.',
            f5Title: 'Bestellungen und Kundschaft',
            f5Body: 'Jede Bestellung wird im Moment des Kaufs festgehalten — Ihre Historie bleibt korrekt, egal wie sich der Katalog später ändert.',
            f6Title: 'Apps und Themes',
            f6Body: 'Ein Partner-Ökosystem mit OAuth, eng gefassten Berechtigungen und Webhooks, um Ihren Shop zu erweitern, ohne Ihre Daten anzufassen.',
        },
        pricing: {
            heading: 'Einfache Preise',
            subheading: 'Kostenlos starten. Aufsteigen, wenn die Bestellungen es tun.',
            perMonth: '/Monat',
            cta: 'Loslegen',
            popular: 'Am beliebtesten',
            placeholderNotice: 'Diese Zahlen sind Platzhalter, solange Upweo in der Beta ist. Heute wird nichts berechnet.',
            empty: 'Die Preise werden gerade finalisiert. Einen Shop zu eröffnen ist bis dahin kostenlos.',
        },
        partners: {
            heading: 'Für Upweo entwickeln',
            subheading: 'Bauen Sie Apps und Themes für Händler — mit echtem OAuth-Flow, eng gefassten Berechtigungen und Webhooks.',
            cta: 'Partner werden',
            signIn: 'Partner-Anmeldung',
            b1Title: 'Echte APIs',
            b1Body: 'Eine öffentliche GraphQL-Storefront-API und eine REST-Admin-API, beide versioniert.',
            b2Title: 'Eng gefasster Zugriff',
            b2Body: 'Händler erteilen genau die Berechtigungen, die Ihre App anfragt — und können sie entziehen.',
            b3Title: 'Webhooks',
            b3Body: 'Abonnieren Sie die Ereignisse, die zählen: signiert zugestellt und automatisch wiederholt.',
        },
        signup: {
            heading: 'Shop eröffnen',
            subheading: 'Dauert etwa eine Minute. Alles davon lässt sich später ändern.',
            submit: 'Meinen Shop eröffnen',
            submitting: 'Shop wird erstellt…',
            haveAccount: 'Verkaufen Sie schon mit Upweo? Anmelden',
            success: 'Ihr Shop ist bereit. Weiter zu Ihrer Verwaltung…',
        },
        partnerSignup: {
            heading: 'Partner werden',
            subheading: 'Sagen Sie uns, wer Sie sind. Wir prüfen neue Partner, bevor ihre Apps öffentlich werden.',
            accountName: 'Firmen- oder Entwicklername',
            submit: 'Partnerkonto erstellen',
            submitting: 'Konto wird erstellt…',
            success: 'Ihr Partnerkonto ist erstellt und wartet auf Prüfung. Weiter zum Portal…',
            haveAccount: 'Schon Partner? Anmelden',
            existingUserHint: 'Sie haben schon ein Upweo-Konto? Nutzen Sie dieselben Zugangsdaten, dann ergänzen wir den Partnerzugang.',
        },
        footer: {
            tagline: 'Mandantenfähiger Handel, offen gebaut.',
            product: 'Produkt',
            forPartners: 'Für Partner',
            rights: '© {{year}} Upweo',
        },
    },
    errors: {
        BAD_REQUEST: 'Diese Anfrage war nicht verständlich.',
        VALIDATION_FAILED: 'Bitte prüfen Sie die markierten Felder.',
        UNAUTHENTICATED: 'Bitte melden Sie sich erneut an.',
        FORBIDDEN: 'Dazu haben Sie keine Berechtigung.',
        TENANT_NOT_RESOLVED: 'Wir konnten nicht ermitteln, um welchen Shop es geht.',
        NOT_FOUND: 'Nicht gefunden.',
        CONFLICT: 'Das steht im Konflikt mit etwas Vorhandenem.',
        RATE_LIMITED: 'Zu viele Versuche. Bitte einen Moment warten.',
        PAYMENT_FAILED: 'Die Zahlung konnte nicht abgeschlossen werden.',
        INTERNAL_ERROR: 'Auf unserer Seite ist etwas schiefgelaufen.',
        network: 'Der Server ist nicht erreichbar. Prüfen Sie Ihre Verbindung.',
    },
    email: {
        orderConfirmation: {
            subject: 'Bestellung {{order}} bestätigt',
            preheader: 'Wir haben Ihre Bestellung und Ihre Zahlung erhalten.',
            heading: 'Vielen Dank für Ihre Bestellung',
            greeting: 'Hallo {{name}},',
            intro: '{{store}} hat Ihre Bestellung erhalten und Ihre Zahlung ist eingegangen.',
            orderLabel: 'Bestellung',
            datePlaced: 'Eingegangen',
            itemsHeading: 'Ihre Bestellung',
            subtotal: 'Zwischensumme',
            shipping: 'Versand',
            tax: 'Steuern',
            total: 'Gesamt',
            shippingTo: 'Lieferadresse',
            nextSteps: 'Wir melden uns wieder, sobald Ihre Bestellung versandt wird.',
            footer: 'Diese E-Mail wurde von {{store}} gesendet.',
        },
        passwordReset: {
            subject: 'Upweo-Passwort zurücksetzen',
            preheader: 'Ein Link, um ein neues Passwort zu wählen.',
            heading: 'Passwort zurücksetzen',
            intro: 'Jemand hat das Zurücksetzen des Passworts für {{email}} angefordert.',
            action: 'Neues Passwort wählen',
            expiry: 'Dieser Link funktioniert einmal und läuft in {{minutes}} Minuten ab.',
            ignore: 'Wenn Sie das nicht waren, können Sie diese E-Mail ignorieren — Ihr Passwort wurde nicht geändert.',
            footer: 'Gesendet von Upweo.',
        },
    },
};
//# sourceMappingURL=de.js.map